import { createSlice } from "@reduxjs/toolkit";

export type SidebarSliceType = {
    itemSelected: string
};

const initialState: SidebarSliceType = { itemSelected: "subscriptions" };

export const sidebarSlice = createSlice({
    name: "sidebar",
    initialState,
    reducers: {
        setItemSelected: (state, value) => {
            state.itemSelected = value.payload;
        }
    }
});

export const { setItemSelected } = sidebarSlice.actions;

export default sidebarSlice.reducer;